import { render, staticRenderFns } from "./IgNavBar.vue?vue&type=template&id=45a386e0&"
import script from "./IgNavBar.vue?vue&type=script&lang=js&"
export * from "./IgNavBar.vue?vue&type=script&lang=js&"
import style0 from "./IgNavBar.vue?vue&type=style&index=0&id=45a386e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports